module.exports = __webpack_public_path__ + "assets/Lozenge.72745819c34ec58098da7db5768e465f.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Lozenge.gmt
// module id = 970
// module chunks = 0